<template>
  <a-card>
    <span slot="title"
      ><a-tag :color="type ? 'red' : 'green'">{{
        type ? type : "Create"
      }}</a-tag>
      Sales Contract</span
    >
    <h4 v-if="mode == 'Edit'" class="margin-remove" slot="extra">
      Amandemen No : {{ dataProcessed.amandemen }}
    </h4>
    <a-steps :current="current" status="process">
      <a-step title="Information" />
      <a-step title="Detail Account" />
      <a-step title="Detail Termin" />
      <a-step title="Document" />
    </a-steps>
    <div
      class="steps-content flex-1"
      :class="
        steps[current].content == 'ProductDetail'
          ? 'padding-remove border-remove'
          : steps[current].content == 'InvoiceDetail'
          ? 'padding-remove'
          : ''
      "
    >
      <component
        class="flex-1"
        :is="steps[current].content"
        :ref="stepRef"
        v-bind="stepProps"
      ></component>
    </div>
    <template class="ant-card-actions" slot="actions">
      <div class="steps-action">
        <a-button v-if="current < steps.length - 1" type="primary" @click="next"
          >Next</a-button
        >
        <a-button
          v-if="current == steps.length - 1"
          :loading="loading"
          type="primary"
          @click="validate"
          >Save</a-button
        >
        <a-button v-if="current > 0" @click="prev">Previous</a-button>
      </div>
    </template>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import Information from "./steps/Information.vue";
import AccountDetail from "./steps/AccountDetail.vue";
import ProductDetail from "./steps/ProductDetail.vue";
import InvoiceDetail from "./steps/InvoiceDetail.vue";
import Document from "./steps/Document.vue";
import CurrencyFormat from "@/mixins/CurrencyFormat";
export default {
  name: "create-index",
  props: ["id", "type"],
  components: {
    Information,
    AccountDetail,
    ProductDetail,
    InvoiceDetail,
    Document,
  },
  mixins: [CurrencyFormat],
  data() {
    return {
      current: 0,
      mode: "Create",
      loading: false,
      steps: [
        {
          title: "Information",
          content: "Information",
        },
        {
          title: "AccountDetail",
          content: "AccountDetail",
        },
        {
          title: "InvoiceDetail",
          content: "InvoiceDetail",
        },
        {
          title: "Document",
          content: "Document",
        },
      ],
      dataProcessed: {
        information: {},
        AccountDetail: {},
        ProductDetail: [],
        InvoiceDetail: [],
        Document: [],
      },
    };
  },
  created() {
    if (this.id) {
      this.mode = "Edit";
      this.$store.commit("setPageModeSalesContract", "Edit");
    } else {
      this.mode = "Create";
      this.$store.commit("setPageModeSalesContract", "Create");
    }
  },
  computed: {
    ...mapGetters([
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getDeletedDocument",
      "getNewDocument",
      "getDetailInvoice",
      "getDocument",
    ]),
    stepProps: function () {
      if (this.steps[this.current].content === "Information") {
        return {
          dataProcessed: this.dataProcessed,
          mode: this.mode,
        };
      } else if (this.steps[this.current].content === "AccountDetail") {
        return {
          dataProcessed: this.dataProcessed,
          mode: this.mode,
        };
      } else if (this.steps[this.current].content === "InvoiceDetail") {
        return {
          dataProcessed: this.dataProcessed,
          mode: this.mode,
        };
      } else if (this.steps[this.current].content === "Document") {
        return {
          dataProcessed: this.dataProcessed,
          mode: this.mode,
        };
      }
    },
    stepRef: function () {
      if (this.steps[this.current].content === "Information") {
        return "refInformation";
      } else if (this.steps[this.current].content === "AccountDetail") {
        return "refAccountDetail";
      } else if (this.steps[this.current].content === "ProductDetail") {
        return "refProductDetail";
      } else if (this.steps[this.current].content === "InvoiceDetail") {
        return "refInvoiceDetail";
      } else if (this.steps[this.current].content === "Document") {
        return "refDocument";
      }
    },
  },
  methods: {
    moment,
    fetch() {
      if (this.mode == "Create") {
        this.$store.dispatch("getMasterCreate", { auth: this.getAuth });
      } else {
        this.$store.dispatch("getMasterCreate", { auth: this.getAuth });
        this.$store
          .dispatch("getEditSC", {
            auth: this.getAuth,
            params: { id: this.id, type: this.type },
          })
          .then((res) => {
            this.dataProcessed = {
              amandemen: res.data.information[0].amandemen_number,
              information: {
                date: res.data.information[0].date,
                sales_notification:
                  res.data.information[0].sales_notification_text,
                kode: res.data.information[0].kode,
                contract_no: res.data.information[0].contract_no,
                description: res.data.information[0].description,
                sktd_ppn_no: res.data.information[0].sktd_ppn_no,
                // pimpro: res.data.information[0].pimpro,
                periode: [
                  res.data.information[0].periode_start_dt,
                  res.data.information[0].periode_end_dt,
                ],
                invoice_to: res.data.information[0].invoice_to,
                id_sales_contract: res.data.information[0].id_sales_contract,
              },
              AccountDetail: {
                bank_account: res.data.detil_account[0].bank_account,
                project_currency: res.data.detil_account[0].project_currency,
                exchange_rate: res.data.detil_account[0].exchange_rate
                  ? res.data.detil_account[0].exchange_rate
                  : 0,
                project_value: res.data.detil_account[0].project_currency
                  ? res.data.detil_account[0].project_value
                  : 0,
                ppn: res.data.detil_account[0].ppn
                  ? res.data.detil_account[0].ppn
                  : "1",
                ppn_value: res.data.detil_account[0].ppn_value
                  ? res.data.detil_account[0].ppn_value
                  : null,
              },
              ProductDetail: res.data.detil_product,
              InvoiceDetail: res.data.detil_invoice,
              note: res.data.information[0].note,
              Document: res.data.document,
            };
          });
      }
    },
    next() {
      if (this.steps[this.current].content === "Information") {
        this.$refs.refInformation.handleRef();
      } else if (this.steps[this.current].content === "AccountDetail") {
        this.$refs.refAccountDetail.handleRef();
      } else if (this.steps[this.current].content === "ProductDetail") {
        this.$refs.refProductDetail.handleRef();
      } else if (this.steps[this.current].content === "InvoiceDetail") {
        this.$refs.refInvoiceDetail.handleRef();
      } else if (this.steps[this.current].content === "Document") {
        this.$refs.refDocument.handleRef();
      }
    },
    prev() {
      this.current--;
    },
    validate() {
      this.$refs.refDocument.handleRef();
    },
    valueFromChild(value) {
      if (this.steps[this.current].content === "Information") {
        this.dataProcessed.information = value;
        this.current++;
      } else if (this.steps[this.current].content === "AccountDetail") {
        this.dataProcessed.AccountDetail = value;
        this.current++;
      } else if (this.steps[this.current].content === "ProductDetail") {
        let ttl = 0;
        let max_min = parseFloat(
          this.dataProcessed.AccountDetail.project_value
        );
        value.forEach((element) => {
          if (this.mode == "Edit") {
            ttl =
              ttl + parseFloat(element.unit_price) * parseFloat(element.qty);
          } else {
            ttl = ttl + parseFloat(element.unitPrice) * parseFloat(element.qty);
          }
        });
        //console.log(value,max_min,ttl)
        if (max_min < ttl) {
          this.displayMessageValue(
            "basic-error",
            "Total Value Detail Product Must Be Less Than Or Equal To Total Project Value ( " +
              this.formatCurrency(
                this.dataProcessed.AccountDetail.project_currency,
                max_min
              ) +
              " ) !"
          );
        } else {
          this.dataProcessed.ProductDetail = value;
          this.current++;
        }
      } else if (this.steps[this.current].content === "InvoiceDetail") {
        this.dataProcessed.InvoiceDetail = value;
        this.current++;
      } else if (this.steps[this.current].content === "Document") {
        this.dataProcessed.Document = value;

        if (this.mode === "Edit") {
          this.confirmMessage("confirm-edit");
        } else {
          this.confirmMessage("confirm-save");
        }
      }
    },
    submit() {
      let postData = new FormData();
      let vuexAction = "";
      this.loading = true;

      postData.append("tlc", this.getAuth.username);
      postData.append(
        "date",
        moment(this.dataProcessed.information.date).format(
          this.getStandartFormatDate
        )
      );
      // postData.append(
      //   "sales_notification",
      //   this.dataProcessed.information.sales_notification
      // );
      postData.append("kode", this.dataProcessed.information.kode);
      postData.append(
        "contract_no",
        this.dataProcessed.information.contract_no
      );
      postData.append(
        "description",
        this.dataProcessed.information.description
      );
      postData.append(
        "sktd_ppn_no",
        this.dataProcessed.information.sktd_ppn_no
      );
      // postData.append("pimpro", this.dataProcessed.information.pimpro);

      postData.append(
        "periode_start",
        this.dataProcessed.information.periode
          ? moment(this.dataProcessed.information.periode[0]).format(
              this.getStandartFormatDate
            )
          : null
      );
      postData.append(
        "periode_end",
        this.dataProcessed.information.periode
          ? moment(this.dataProcessed.information.periode[1]).format(
              this.getStandartFormatDate
            )
          : null
      );
      postData.append("invoice_to", this.dataProcessed.information.invoice_to);
      if (this.dataProcessed.AccountDetail.bank_account) {
        postData.append(
          "bank_account",
          this.dataProcessed.AccountDetail.bank_account
        );
      }
      postData.append(
        "project_currency",
        this.dataProcessed.AccountDetail.project_currency
      );
      postData.append(
        "exchange_rate",
        this.dataProcessed.AccountDetail.exchange_rate
      );
      postData.append(
        "project_value",
        this.dataProcessed.AccountDetail.project_value
      );
      postData.append("ppn", this.dataProcessed.AccountDetail.ppn);
      postData.append("ppn_value", this.dataProcessed.AccountDetail.ppn_value);

      this.dataProcessed.InvoiceDetail.forEach((data, index) => {
        postData.append(`detil_invoice[${index}][periode]`, moment(data.periode).format('YYYY-MM'));
        postData.append(`detil_invoice[${index}][work_name]`, data.work_name);
        postData.append(`detil_invoice[${index}][value]`, data.value);
        postData.append(`detil_invoice[${index}][remark]`, data.remark);
        postData.append(`detil_invoice[${index}][ppn_sktd]`, data.ppn_sktd);
        postData.append(
          `detil_invoice[${index}][ppn_dipungut]`,
          data.ppn_dipungut
        );
        postData.append(
          `detil_invoice[${index}][ppn_memungut]`,
          data.ppn_memungut
        );
        postData.append(`detil_invoice[${index}][ppn_migas]`, data.ppn_migas);
        postData.append(`detil_invoice[${index}][pph22]`, data.pph22_15);
        postData.append(`detil_invoice[${index}][fee_lain]`, data.fee_lain);
        postData.append(`detil_invoice[${index}][taktis]`, data.taktis);
        postData.append(
          `detil_invoice[${index}][date_invoice]`,
          moment(data.date_invoice).format(this.getStandartFormatDate)
        );

        if (this.mode == "Edit") {
          postData.append(
            `detil_invoice[${index}][id_sc_dtl_invoice]`,
            data.id_sc_dtl_invoice
          );
        }

        postData.append(`detil_invoice[${index}][unit_price]`, data.unit_price);
        postData.append(`detil_invoice[${index}][qty]`, data.qty);
        postData.append(`detil_invoice[${index}][unit]`, data.unit);
      });
      if (this.mode == "Create") {
        this.dataProcessed.Document.forEach((data, index) => {
          postData.append(`document_description[${index}]`, data.description);
          postData.append(`select_document[${index}]`, data.document);
        });
      } else {
        this.getNewDocument.forEach((data, index) => {
          postData.append(`document_description[${index}]`, data.description);
          postData.append(`select_document[${index}]`, data.document);
        });

        this.getDocument.forEach((data, index) => {
          postData.append(`document_old[${index}][id]`, data.id);
        });
      }
      postData.append("note", this.dataProcessed.note ? this.dataProcessed.note :'');
      postData.append("tipe", this.type);

      // this.getDeletedDocument.forEach((data, index) => {
      //   postData.append(`document_old[${index}][id]`, data.id);
      // });

      if (this.mode == "Edit") {
        postData.append("id_sales_contract", this.id);
        vuexAction = "postEditSalesContract";
      } else {
        vuexAction = "postSalesContract";
      }

      this.$store
        .dispatch(vuexAction, {
          auth: this.getAuth,
          payload: postData,
        })
        .then((res) => {
          this.displayMessage("success-save");
          this.loading = false;
          this.$store.dispatch("resetState");
          this.$router.push({ name: "salesContract" });
        })
        .catch((err) => {
          console.log("error : " + err);
          this.loading = false;
          let response = Object.assign({}, err.response);
          if (response.data.status == false && response.data.message) {
            this.displayMessageValue("error-other", response.data.message);
          } else {
            let responses = Object.assign({}, err.response.data);
            //console.log(responses);
            this.displayMessageValue("error", responses);
          }
        });
    },
    refreshInvoiceDetail() {
      this.dataProcessed.InvoiceDetail = this.getDetailInvoice;
    },
    refreshProductDetail(){
      this.dataProcessed.ProductDetail = this.getDetailProduct;
    }
  },
  mounted() {
    this.fetch();
    this.$store.dispatch("FETCH_ALL_KARYAWAN");
    Event.$on("dataProcessed", this.valueFromChild);
    Event.$on("refreshInvoiceDetail", this.refreshInvoiceDetail);
    Event.$on("refreshProductDetail", this.refreshProductDetail);
    Event.$on("confirmMessageReturn", this.submit);
  },
  beforeDestroy() {
    Event.$off("dataProcessed", this.valueFromChild);
    Event.$off("refreshInvoiceDetail", this.refreshInvoiceDetail);
    Event.$off("refreshProductDetail", this.refreshProductDetail);
    Event.$off("confirmMessageReturn", this.submit);
  },
};
</script>

<style>
</style>